export default "__VITE_ASSET__BCeUqmu___"